import * as React from 'react'

import { useApolloClient } from '@apollo/client'

import { uploadPublicFile } from '~/client/src/shared/services/publicFileUpload'

import { FileUploadFn } from '../DynamicForm/types'

export function useResourceFileUpload(): FileUploadFn {
  const apolloClient = useApolloClient()

  return React.useCallback(
    (file: File) => uploadPublicFile(apolloClient, file),
    [apolloClient],
  )
}
